var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3V4H12V3C12 2.46875 12.4375 2 13 2C13.5312 2 14 2.46875 14 3V4H15.5C16.3125 4 17 4.6875 17 5.5V7H3V5.5C3 4.6875 3.65625 4 4.5 4H6V3C6 2.46875 6.4375 2 7 2C7.53125 2 8 2.46875 8 3ZM3 8H17V16.5C17 17.3438 16.3125 18 15.5 18H4.5C3.65625 18 3 17.3438 3 16.5V8ZM5 11.5C5 11.7812 5.21875 12 5.5 12H6.5C6.75 12 7 11.7812 7 11.5V10.5C7 10.25 6.75 10 6.5 10H5.5C5.21875 10 5 10.25 5 10.5V11.5ZM9 11.5C9 11.7812 9.21875 12 9.5 12H10.5C10.75 12 11 11.7812 11 11.5V10.5C11 10.25 10.75 10 10.5 10H9.5C9.21875 10 9 10.25 9 10.5V11.5ZM13.5 10C13.2188 10 13 10.25 13 10.5V11.5C13 11.7812 13.2188 12 13.5 12H14.5C14.75 12 15 11.7812 15 11.5V10.5C15 10.25 14.75 10 14.5 10H13.5ZM5 15.5C5 15.7812 5.21875 16 5.5 16H6.5C6.75 16 7 15.7812 7 15.5V14.5C7 14.25 6.75 14 6.5 14H5.5C5.21875 14 5 14.25 5 14.5V15.5ZM9.5 14C9.21875 14 9 14.25 9 14.5V15.5C9 15.7812 9.21875 16 9.5 16H10.5C10.75 16 11 15.7812 11 15.5V14.5C11 14.25 10.75 14 10.5 14H9.5ZM13 15.5C13 15.7812 13.2188 16 13.5 16H14.5C14.75 16 15 15.7812 15 15.5V14.5C15 14.25 14.75 14 14.5 14H13.5C13.2188 14 13 14.25 13 14.5V15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5841ab54b924cc5cf48e188e632a287d.svg";
export { ForwardRef as ReactComponent };